export default __webpack_public_path__ + "static/media/concierge-recipe-page.2f6c4bcd.svg";